import React from 'react'
import * as Icon from 'react-feather';
const SentQueryBox = props => {
    return (
        <label className="py-1 bg-vp rounded-full border border-primary relative flex justify-center items-center m-2" >
            <p  name={props.name} value={props.value} {...props} />            
            <span><small  dangerouslySetInnerHTML={{ __html: props.label }}></small></span>
        </label>
    )
}



export default SentQueryBox
